import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase'; // Import your Firebase auth instance
import { getDoc, doc } from 'firebase/firestore';
import db from '../firebase'; // Import your Firestore instance
import '../styles/login.css'; // Import the CSS file

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate(); // Initialize useNavigate

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            console.log('Signed in:', userCredential.user.uid);

            // Check if the user is approved
            const userDoc = await getDoc(doc(db, 'users', user.uid));
            if (userDoc.exists() && userDoc.data().isApproved) {
                // User is approved, redirect to articles page
                navigate('/articles');
            } else {
                // User is not approved, sign out and show an error message
                await auth.signOut();
                setError('Your account is pending approval.');
            }
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className="login-container">
            <div className="login-form">
                <h2>Login to The Climate Spectrum</h2>
                {error && <p>{error}</p>}
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        id="email"
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        id="password"
                    />
                    <button type="submit" id="submit">Login</button>
                </form>
            </div>
        </div>
    );
}

export default Login;